import React, { useEffect, useState } from 'react';
import { Container, TitleContainer, InputTitle, TrashButton, ItensList } from './styles';
import { Column } from '../styles';
import { Droppable, Draggable } from 'react-beautiful-dnd';
// import MoveIcon from '../MoveIcon';
// import Trash from '../Trash';
import { MoveIcon, Trash } from '../../Components';

/**
 * Container individual de cada coluna exibida
 * @param {boolean} allowEdit permissão para editar
 * @param {object} column Json com configurações dos objetos a serem exibidos
 * @param {Int} index index da coluna
 * @param {Function} changeColumnTitle função para alterar o titulo da coluna
 * @param {Function} removeColumn função excluir uma coluna
 * @returns {ReactComponentElement} 
 */
const ColumnContainer = ({allowEdit, IsDetail, column, index, changeColumnTitle, removeColumn, children}) => {
    const childs = React.Children.toArray(children);
    const [currentTitle, setCurrentTitle] = useState(column.name);
    const [fillButon, setFillButon] = useState('#FF3939');

    const changeTitle = () => {
        if(currentTitle === null || currentTitle === undefined || currentTitle === ''){
            changeColumnTitle(false)
            return
        }
        column.name = currentTitle
        changeColumnTitle(column);
    }
    
    useEffect(() => {
        setCurrentTitle(column.name)
    }, [column]);

    return (
        <Draggable draggableId={column.id} index={index} isDragDisabled={!allowEdit}>
            {(provided, snapshot) => (
                <Container
                    $IsDetail={IsDetail}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    $isDragging={snapshot.isDragging}>
                        
                    <TitleContainer {...provided.dragHandleProps}>
                        <Column $width={'10%'}>
                            {allowEdit ? 
                                <MoveIcon/>
                                :
                                <></>
                            }
                        </Column>
                        
                        <InputTitle value={currentTitle} onChange={(e) => {setCurrentTitle(e.target.value)}} onBlur={() => {changeTitle()}} readOnly={!allowEdit}/>

                        <Column $width={'10%'}>
                            {allowEdit ? 
                                <TrashButton 
                                onClick={() => {removeColumn(column)}} 
                                onOver={() => setFillButon('#fff')} 
                                onMouseOut={() => setFillButon('#FF3939')}>
                                    <Trash Fill={fillButon}/>
                                </TrashButton>
                                :
                                <></>
                            }
                        </Column>
                    </TitleContainer>

                    <Droppable droppableId={column.id} type='task'>
                        {(provided, snapshot) => (

                            <ItensList
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                $isDraggingOver={snapshot.isDraggingOver}
                            >
                                {childs.map(child => {
                                    return child;
                                })}
                                {provided.placeholder}
                            </ItensList>
                        )}
                    </Droppable>

                </Container>

            )}
        </Draggable>
    )
}

export default ColumnContainer;